var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.586 9.35772H10.7L19.4008 21.6745H21.2935L12.586 9.35772Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9967 0.00634766C7.34842 0.00634766 0.336456 6.94509 0.336456 15.5031C0.336456 24.0611 7.34842 30.9998 15.9967 30.9998C24.645 30.9998 31.657 24.0611 31.657 15.5031C31.657 6.94509 24.6516 0.00634766 15.9967 0.00634766ZM18.8225 22.5524L15.0175 17.0768L10.2531 22.5524H9.02419L14.4721 16.29L9.02419 8.4473H13.1775L16.7787 13.6367L21.2869 8.4473H22.5158L17.3242 14.4236L22.9758 22.5589H18.8225V22.5524Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.a1ade9754b3cca0c3638f9ad3c726a13.svg";
export { ForwardRef as ReactComponent };